<template>
  <v-card>
    <v-card-title>
      <span class="headline">Login</span>
    </v-card-title>
    <v-card-subtitle>Re enter your password to login.</v-card-subtitle>
    <v-card-text>
      <ValidationObserver ref="validator">
        <ValidationProvider
          rules="required"
          name="password"
          label="Password"
          required
          v-slot="{ errors }"
        >
          <v-text-field
            :append-icon="showPassword ? '$show' : '$hide'"
            :type="showPassword ? 'text' : 'password'"
            name="password"
            v-model="request.password"
            label="Type your password"
            class="mb-8"
            :error-messages="errors"
            @click:append="showPassword = !showPassword"
          />
        </ValidationProvider>
      </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="primary" x-large @click.prevent.stop="submit()">
        Login
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Request from '@request/Auth/LoginRequest';

export default {
  name: 'SessionReset',
  data() {
    return {
      showPassword: false,
      request: new Request(this.$refs, {
        email: this.$store.state.auth.user.email,
        password: '',
      }),
    };
  },
  methods: {
    async submit() {
      if (await this.$refs.validator.validate()) {
        let response = await this.request.submit();
        if (response) {
          this.$bus.$emit('session-refreshed');
        }
      }
    },
  },
};
</script>

<style scoped></style>
